<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<ng-template #addDependencyPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeDependencyPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popup.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 615px !important;">
      <ng-container *ngIf="dependency.mode == 'create'">
        <div class="row dependency">
          <div class="col-md-6">
            <div>
              <label for="email">Group</label>
              <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="dependency.groupId" (closed)="groupSearchText=''"
              (click)="focusSearch('group-search')" (keydown.enter)="focusSearch('group-search')">
              <input type="search" id="group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
                placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onGroupSelect($event, null)">Un-select</mat-option>
              <mat-option *ngFor="let item of groupDropdown | assessmentSearch :groupSearchText"
                (onSelectionChange)="onGroupSelect($event, item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-6">
            <div><label for="email">Module</label><span class="mandatory-symbol">*</span></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="dependency.module" (closed)="moduleSearchText=''"
              (click)="focusSearch('module-search')" (keydown.enter)="focusSearch('module-search')">
              <input type="search" id="module-search" class="dropdownsearchstyle" [(ngModel)]="moduleSearchText"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onModuleSelect($event, null)">Un-select</mat-option>
              <mat-option *ngFor="let item of moduleDropdown| assessmentSearch :moduleSearchText"
                (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
            <span *ngIf="dependency.module" style="font-style: italic; font-size: x-small; color: var(--primary)">
              Modules are displaying based on the group configuration
            </span>
          </div>
        </div>

        <ng-container *ngIf="dependency.showModule && dynamicLabel">
          <div class="row">
            <!-- ************************** Change Request *********************************** -->
            <ng-container *ngIf="dependency.module == 'CR'">
              <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME']?.isRemovable=='Y'">
                <div>
                  <label id="cr-dept" for="email">
                    {{dynamicLabel['DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cr.deptCode" (closed)="departmentSearchText=''"
                  (click)="focusSearch('focus-cr-dept')" (keydown.enter)="focusSearch('focus-cr-dept')">
                  <input type="search" id="focus-cr-dept" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="cr-owner" for="email">
                    {{dynamicLabel['OWNER_USER_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OWNER_USER_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cr.owner" (closed)="ownerSearchText=''"
                  (click)="focusSearch('focus-cr-owner')" (keydown.enter)="focusSearch('focus-cr-owner')">
                  <input type="search" id="focus-cr-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onOwnerSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of ownerDropdown | assessmentSearch : ownerSearchText"
                    (onSelectionChange)="onOwnerSelect($event, item)" [value]="item.valueExp"
                    [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="cr-type" for="email">
                    {{dynamicLabel['CHANGE_TYPE_CODE']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['CHANGE_TYPE_CODE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CHANGE_TYPE_CODE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cr.changeTypeCode" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-cr-type')" (keydown.enter)="focusSearch('focus-cr-type')">
                  <input type="search" id="focus-cr-type" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onTypeSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of typeDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="cr-requested-at" for="email">
                    {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cr.requestedAt"
                  (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
                  (keydown.enter)="focusSearch('focus-cr-requested-at')">
                  <input type="search" id="focus-cr-requested-at" class="dropdownsearchstyle"
                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" (onSelectionChange)="onRequestedAtSelect($event, null)"
                    [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="cr.requestedAt">
                <div>
                  <label id="cr-business-area" for="email">
                    {{((dependency.requestedAtName ?? ' ') + " " + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea
                  [(ngModel)]="dependency.selectedBusinessArea" *ngIf="businessAreaDropdown.length"
                  (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
                  (click)="focusSearch('focus-cr-b-area')" (keydown.enter)="focusSearch('focus-cr-b-area')">
                  <input type="search" id="focus-cr-b-area" class="dropdownsearchstyle"
                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllBusinessAreaSelected"
                      (change)="toggleAllBusinessArea()">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  *ngIf="!businessAreaDropdown.length" [(ngModel)]="cr.coreBusinessAreaName"
                  (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="cr-ex-to-be-started-on" for="email">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="cr.expectedToBeStartedOn"
                  (ngModelChange)="onExpectedToBeStartedOnChange($event); onNgModelChange(cr.expectedToBeStartedOn, 'cr-ex-to-be-started-on')">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="cr-closure-on" for="email">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"><img [src]="qualityService.noteIcon"
                      alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="cr.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(cr.expcetedClosureOn, 'cr-closure-on')">
              </div>

              <div class="col-md-3" *ngIf="dependency.groupDetail?.effectivenessCheckEnabled == 'Y'">
                <div>
                  <label for="email">
                    {{dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="cr.effectivenessCheckReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: cr.effectivenessCheckReqd ? 'green' : 'red' }">
                    {{ cr.effectivenessCheckReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="cr-short-description" for="email">
                    {{dynamicLabel['SHORT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="100"
                  [(ngModel)]="cr.shortDescription"
                  (ngModelChange)="onNgModelChange(cr.shortDescription, 'cr-short-description')">
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['CHANGE_DESCRIPTION']?.isRemovable=='Y'">
                <div>
                  <label id="cr-description" for="email">
                    {{dynamicLabel['CHANGE_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['CHANGE_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CHANGE_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="cr.changeDescription" [config]="excludeButtons" [spellcheck]="true"
                      (paste)="onPaste($event)"
                      (ngModelChange)="onStEditorChange(cr.changeDescription, 'cr-description')"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Change Description')"
                      (keydown.enter)="openEditor('Change Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['CHANGE_JUSTIFICATION']?.isRemovable=='Y'">
                <div>
                  <label id="cr-justification" for="email">
                    {{dynamicLabel['CHANGE_JUSTIFICATION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['CHANGE_JUSTIFICATION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CHANGE_JUSTIFICATION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="cr.changeJustification" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(cr.changeJustification, 'cr-justification')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Change Justification')"
                      (keydown.enter)="openEditor('Change Justification')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['REASON_FOR_CHANGE_CODE']?.isRemovable=='Y'">
                <div>
                  <label id="cr-reason" for="email">
                    {{dynamicLabel['REASON_FOR_CHANGE_CODE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_CHANGE_CODE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REASON_FOR_CHANGE_CODE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput multiple #reason placeholder="Select" [(ngModel)]="dependency.selectedReason"
                  (closed)="reasonSearchText=''" (click)="focusSearch('focus-cr-reason')"
                  (keydown.enter)="focusSearch('focus-cr-reason')">
                  <input type="search" id="focus-cr-reason" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
                    matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllReasonSelected" (change)="toggleAllReason()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item1 of reasonDropdown | multiAssessmentSearchPipe : reasonSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onReasonSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6"
                *ngIf="visibleReasonForOthers && dynamicLabel['REASON_FOR_CHANGE_CODE']?.isRemovable != 'Y'">
                <div>
                  <label id="cr-reason-if-others" for="email">
                    {{dynamicLabel['REASON_FOR_CHANGE_CODE']?.fieldName}} If Others
                  </label><span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="cr.reasonForChange"></textarea>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="cr.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: cr.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ cr.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <!-- ************************** CAPA *********************************** -->
            <ng-container *ngIf="dependency.module == 'CAPA'">
              <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME']?.isRemovable=='Y'">
                <div>
                  <label id="capa-dept" for="email">
                    {{dynamicLabel['DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes"><img [src]="qualityService.noteIcon" alt="note"
                      width="18" height="18"></span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="capa.deptCode" (closed)="departmentSearchText=''"
                  (click)="focusSearch('focus-capa-dept')" (keydown.enter)="focusSearch('focus-capa-dept')">
                  <input type="search" id="focus-capa-dept" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onDepartmentSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch :departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="capa-owner" for="email">
                    {{dynamicLabel['OWNER_USER_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OWNER_USER_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="capa.owner" (closed)="ownerSearchText=''"
                  (click)="focusSearch('focus-capa-owner')" (keydown.enter)="focusSearch('focus-capa-owner')">
                  <input type="search" id="focus-capa-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onOwnerSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of ownerDropdown | assessmentSearch : ownerSearchText"
                    (onSelectionChange)="onOwnerSelect($event, item)" [value]="item.valueExp"
                    [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="capa-type" for="email">
                    {{dynamicLabel['CAPA_TYPE']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['CAPA_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CAPA_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="capa.capaType" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-capa-type')" (keydown.enter)="focusSearch('focus-capa-type')">
                  <input type="search" id="focus-capa-type" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onTypeSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of typeDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="capa-requested-at" for="email">
                    {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="capa.requestedAt"
                  (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
                  (keydown.enter)="focusSearch('focus-capa-requested-at')">
                  <input type="search" id="focus-capa=requested-at" class="dropdownsearchstyle"
                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="capa.requestedAt">
                <div>
                  <label id="capa-business-area" for="email">
                    {{((dependency.requestedAtName ?? ' ') + " " + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea
                  [(ngModel)]="dependency.selectedBusinessArea" *ngIf="businessAreaDropdown.length"
                  (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
                  (click)="focusSearch('focus-capa-owner-area')" (keydown.enter)="focusSearch('focus-capa-b-area')">
                  <input type="search" id="focus-capa-b-area" class="dropdownsearchstyle"
                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllBusinessAreaSelected"
                      (change)="toggleAllBusinessArea()">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  *ngIf="!businessAreaDropdown.length" [(ngModel)]="capa.coreBusinessAreaName"
                  (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="capa-ex-to-be-started-on" for="email">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="capa.expectedToBeStartedOn" (ngModelChange)="onExpectedToBeStartedOnChange($event);">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="capa-closure-on" for="email">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"><img [src]="qualityService.noteIcon"
                      alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="capa.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(capa.expcetedClosureOn, 'capa-closure-on')">
              </div>

              <div class="col-md-3" *ngIf="dependency.groupDetail?.effectivenessCheckEnabled == 'Y'">
                <div>
                  <label for="email">
                    {{dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="capa.effectivenessCheckReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: capa.effectivenessCheckReqd ? 'green' : 'red' }">
                    {{ capa.effectivenessCheckReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="capa-short-description" for="email">
                    {{dynamicLabel['SHORT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="100"
                  [(ngModel)]="capa.shortDescription">
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['CAPA_DESCRIPTION']?.isRemovable=='Y'">
                <div>
                  <label id="capa-description" for="email">
                    {{dynamicLabel['CAPA_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['CAPA_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CAPA_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="capa.capaDescription" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(capa.capaDescription, 'capa-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('CAPA Description')"
                      (keydown.enter)="openEditor('CAPA Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['REASON_FOR_CAPA_CODE']?.isRemovable=='Y'">
                <div>
                  <label id="capa-reason" for="email">
                    {{dynamicLabel['REASON_FOR_CAPA_CODE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_CAPA_CODE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REASON_FOR_CAPA_CODE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput multiple #reason placeholder="Select" [(ngModel)]="dependency.selectedReason"
                  (closed)="reasonSearchText=''" (click)="focusSearch('focus-capa-reason')"
                  (keydown.enter)="focusSearch('focus-capa-reason')">
                  <input type="search" id="focus-capa-reason" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
                    matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllReasonSelected" (change)="toggleAllReason()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item1 of reasonDropdown | multiAssessmentSearchPipe : reasonSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onReasonSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6"
                *ngIf="visibleReasonForOthers && dynamicLabel['REASON_FOR_CAPA_CODE']?.isRemovable != 'Y'">
                <div>
                  <label id="capa-reason-if-others" for="email">
                    {{dynamicLabel['REASON_FOR_CAPA_CODE']?.fieldName}} If Others
                  </label><span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="capa.reasonForCapa"></textarea>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="capa.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: capa.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ capa.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <!-- ************************** Deviation *********************************** -->
            <ng-container *ngIf="dependency.module == 'DV'">
              <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME']?.isRemovable == 'Y'">
                <div>
                  <label id="dv-dept" for="email">
                    {{dynamicLabel['DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="dv.deptCode" (closed)="departmentSearchText=''"
                  (click)="focusSearch('focus-dv-dept')" (keydown.enter)="focusSearch('focus-dv-dept')">
                  <input type="search" id="focus-dv-dept" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onDepartmentSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="dv-owner" for="email">
                    {{dynamicLabel['OWNER_USER_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OWNER_USER_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="dv.owner" (closed)="ownerSearchText=''"
                  (click)="focusSearch('focus-dv-owner')" (keydown.enter)="focusSearch('focus-dv-owner')">
                  <input type="search" id="focus-dv-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onOwnerSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of ownerDropdown | assessmentSearch : ownerSearchText"
                    (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp"
                    [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="dv-type" for="email">
                    {{dynamicLabel['DEVIATION_TYPE']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['DEVIATION_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEVIATION_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="dv.deviationType" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-dv-type')" (keydown.enter)="focusSearch('focus-dv-type')">
                  <input type="search" id="focus-dv-type" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onTypeSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of typeDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['DEVIATION_CRITICALITY']?.isRemovable=='Y'">
                <div>
                  <label id="dv-criticality" for="email">
                    {{dynamicLabel['DEVIATION_CRITICALITY']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEVIATION_CRITICALITY']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEVIATION_CRITICALITY']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="dv.deviationCriticality"
                  (closed)="typeSearchText=''" (click)="focusSearch('focus-dv-criticality')"
                  (keydown.enter)="focusSearch('focus-dv-criticality')">
                  <input type="search" id="focus-dv-criticality" class="dropdownsearchstyle"
                    [(ngModel)]="typeSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onDvCriticalitySelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of dvCriticalityDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onDvCriticalitySelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="dv-requested-at" for="email">
                    {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="dv.requestedAt"
                  (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-dv-requested-at')"
                  (keydown.enter)="focusSearch('focus-dv-requested-at')">
                  <input type="search" id="focus-dv-requested-at" class="dropdownsearchstyle"
                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch : requestedAtSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="dv.requestedAt">
                <div>
                  <label id="dv-business-area" for="email">
                    {{((dependency.requestedAtName ?? ' ') + " " + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea
                  [(ngModel)]="dependency.selectedBusinessArea" *ngIf="businessAreaDropdown.length"
                  (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
                  (click)="focusSearch('focus-dv-b-area')" (keydown.enter)="focusSearch('focus-dv-b-area')">
                  <input type="search" id="focus-dv-b-area" class="dropdownsearchstyle"
                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllBusinessAreaSelected"
                      (change)="toggleAllBusinessArea()">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  *ngIf="!businessAreaDropdown.length" [(ngModel)]="dv.coreBusinessAreaName"
                  (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['DEVIATION_OCCURED_ON'].isRemovable=='Y'">
                <div>
                  <label id="dv-occurred-on" for="dv-occurred-on">
                    {{dynamicLabel['DEVIATION_OCCURED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEVIATION_OCCURED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEVIATION_OCCURED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="dv.deviationOccuredOn" (ngModelChange)="onNgModelChange($event, 'dv-occurred-on')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['DEVIATION_IDENTIFIED_ON'].isRemovable=='Y'">
                <div>
                  <label id="dv-identified-on" for="dv-identified-on">
                    {{dynamicLabel['DEVIATION_IDENTIFIED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DEVIATION_IDENTIFIED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEVIATION_IDENTIFIED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getIdentifiedOnConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="dv.deviationIdentifiedOn" (ngModelChange)="onNgModelChange($event, 'dv-identified-on')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="dv-ex-to-be-started-on" for="dv-expected-to-started-on">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="dv.expectedToBeStartedOn" (ngModelChange)="onExpectedToBeStartedOnChange($event);">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="dv-closure-on" for="dv-closure-on">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="dv.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(dv.expcetedClosureOn, 'dv-closure-on')">
              </div>

              <div class="col-md-3" *ngIf="dependency.groupDetail?.effectivenessCheckEnabled == 'Y'">
                <div>
                  <label for="email">
                    {{dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="dv.effectivenessCheckReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: dv.effectivenessCheckReqd ? 'green' : 'red' }">
                    {{ dv.effectivenessCheckReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="dv-short-description" for="email">
                    {{dynamicLabel['SHORT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="100"
                  [(ngModel)]="dv.shortDescription">
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['DV_DESCRIPTION']?.isRemovable=='Y'">
                <div>
                  <label id="dv-description" for="email">
                    {{dynamicLabel['DV_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DV_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DV_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="dv.dvDescription" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(dv.dvDescription, 'dv-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Deviation Description')"
                      (keydown.enter)="openEditor('Deviation Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['REASON_FOR_DEVIATION_CODE']?.isRemovable=='Y'">
                <div>
                  <label id="dv-reason" for="email">
                    {{dynamicLabel['REASON_FOR_DEVIATION_CODE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['REASON_FOR_DEVIATION_CODE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REASON_FOR_DEVIATION_CODE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput multiple #reason placeholder="Select" [(ngModel)]="dependency.selectedReason"
                  (closed)="reasonSearchText=''" (click)="focusSearch('focus-dv-reason')"
                  (keydown.enter)="focusSearch('focus-dv-reason')">
                  <input type="search" id="focus-dv-reason" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
                    matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllReasonSelected" (change)="toggleAllReason()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item1 of reasonDropdown | multiAssessmentSearchPipe : reasonSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onReasonSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6"
                *ngIf="visibleReasonForOthers && dynamicLabel['REASON_FOR_DEVIATION_CODE']?.isRemovable != 'Y'">
                <div>
                  <label id="dv-reason-if-others" for="email">
                    {{dynamicLabel['REASON_FOR_DEVIATION_CODE']?.fieldName}} If Others
                  </label><span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="dv.reasonForDeviationCode"></textarea>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="dv.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: dv.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ dv.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <!-- ************************** Incident *********************************** -->
            <ng-container *ngIf="dependency.module == 'IN'">
              <div class="col-md-3">
                <div>
                  <label id="in-type" for="in-type">
                    {{dynamicLabel['IN_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IN_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IN_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.inType" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-in-type')" (keydown.enter)="focusSearch('focus-in-type')">
                  <input type="search" id="focus-in-type" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onTypeSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of typeDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME']?.isRemovable == 'Y'">
                <div>
                  <label id="in-dept" for="department">
                    {{dynamicLabel['DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.deptCode"
                  (closed)="departmentSearchText=''" (click)="focusSearch('focus-in-dept')"
                  (keydown.enter)="focusSearch('focus-in-dept')">
                  <input type=" search" id="focus-in-dept" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onDepartmentSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="in-requested-at" for="requested-at">
                    {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.requestedAt"
                  (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-in-requested-at')"
                  (keydown.enter)="focusSearch('focus-in-requested-at')">
                  <input type="search" id="focus-in-requested-at" class="dropdownsearchstyle"
                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onRequestedAtSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch : requestedAtSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="incident.requestedAt">
                <div>
                  <label id="in-business-area" for="email">
                    {{((dependency.requestedAtName ?? ' ') + " " + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea
                  [(ngModel)]="dependency.selectedBusinessArea" *ngIf="businessAreaDropdown.length"
                  (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
                  (click)="focusSearch('focus-in-b-area')" (keydown.enter)="focusSearch('focus-in-b-area')">
                  <input type="search" id="focus-in-b-area" class="dropdownsearchstyle"
                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllBusinessAreaSelected"
                      (change)="toggleAllBusinessArea()">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  *ngIf="!businessAreaDropdown.length" [(ngModel)]="incident.coreBusinessAreaName"
                  (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="in-reference" for="reference">
                    {{dynamicLabel['REFERENCE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REFERENCE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REFERENCE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.reference"
                  (closed)="referenceSearchText=''" (click)="focusSearch('focus-in-reference')"
                  (keydown.enter)="focusSearch('focus-in-reference')">
                  <input type="search" id="focus-in-reference" class="dropdownsearchstyle"
                    [(ngModel)]="referenceSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onReferenceSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of referenceDropdown | assessmentSearch : referenceSearchText"
                    (onSelectionChange)="onReferenceSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="visibleReferenceIfOthers">
                <div>
                  <label id="in-reference-others" for="reference-others">
                    Reference if Others
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="incident.referenceOthers"
                  (ngModelChange)="onNgModelChange($event,'in-reference-others')"></textarea>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="in-identified-on" for="in-identified-on">
                    {{dynamicLabel['IDENTIFIED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['IDENTIFIED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IDENTIFIED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="incident.identifiedOn" (ngModelChange)="onNgModelChange($event, 'in-identified-on')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="in-ex-to-be-started-on" for="in-expected-to-started-on">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="incident.expectedToBeStartedOn" (ngModelChange)="onExpectedToBeStartedOnChange($event);">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="in-closure-on" for="in-closure-on">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="incident.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(dv.expcetedClosureOn, 'dv-closure-on')">
              </div>

              <div class="col-md-3">
                <div>
                  <label for="email">Initiated On Behalf of Others?</label>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="incident.initiatedOnBehalfByOthers">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: incident.initiatedOnBehalfByOthers ? 'green' : 'red' }">
                    {{ incident.initiatedOnBehalfByOthers ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-3" *ngIf="incident.initiatedOnBehalfByOthers">
                <div>
                  <label for="out-org">
                    {{dynamicLabel['IS_OUTSIDE_ORGANIZATION']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_OUTSIDE_ORGANIZATION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_OUTSIDE_ORGANIZATION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="incident.isOutsideOrganization"
                  (change)="onIsOutsideOrganizationChange($event)">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: incident.isOutsideOrganization ? 'green' : 'red' }">
                    {{ incident.isOutsideOrganization ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-3" *ngIf="incident.initiatedOnBehalfByOthers">
                <div>
                  <label id="behalf-on-others" for="behalf-of-others">
                    {{dynamicLabel['INITIATED_ON_BEHALF_BY']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INITIATED_ON_BEHALF_BY']?.fieldNotes"
                    [matTooltip]="dynamicLabel['INITIATED_ON_BEHALF_BY']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.initiatedOnBehalf"
                  (closed)="qualityUserSearchText=''" (keydown.enter)="focusSearch('focus-behalf-of')"
                  (click)="focusSearch('focus-behalf-of')">
                  <input type="search" id="focus-behalf-of" class="dropdownsearchstyle"
                    [(ngModel)]="qualityUserSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onBehalfSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of qualityUserDropdown | assessmentSearch : qualityUserSearchText"
                    (onSelectionChange)="onBehalfSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="in-impact-type" for="impact-type">
                    {{dynamicLabel['IMPACT_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="incident.impactType"
                  (closed)="impactTypeSearchText=''" (click)="focusSearch('focus-in-impact-type')"
                  (keydown.enter)="focusSearch('focus-in-impact-type')">
                  <input type="search" id="focus-in-impact-type" class="dropdownsearchstyle"
                    [(ngModel)]="impactTypeSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onImpactTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of impactTypeDropdown | assessmentSearch : impactTypeSearchText"
                    (onSelectionChange)="onImpactTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="in-impact-description" for="in-impact-description">
                    {{dynamicLabel['IMPACT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="incident.impactDescription" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(incident.impactDescription,'in-impact-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Impact Description')"
                      (keydown.enter)="openEditor('Impact Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="in-short-description" for="email">
                    {{dynamicLabel['SHORT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="100"
                  [(ngModel)]="incident.shortDescription">
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['DESCRIPTION']?.isRemovable=='Y'">
                <div>
                  <label id="in-description" for="email">
                    {{dynamicLabel['DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="incident.description" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(incident.description, 'in-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Incident Description')"
                      (keydown.enter)="openEditor('Incident Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-3" *ngIf="dependency.groupDetail?.effectivenessCheckEnabled == 'Y'">
                <div>
                  <label for="email">
                    {{dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="incident.effectivenessCheckReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: incident.effectivenessCheckReqd ? 'green' : 'red' }">
                    {{ incident.effectivenessCheckReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="incident.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: incident.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ incident.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <!-- ************************** Quality Issue *********************************** -->
            <ng-container *ngIf="dependency.module == 'QI'">
              <div class="col-md-3">
                <div>
                  <label id="qi-type" for="qi-type">
                    {{dynamicLabel['QI_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['QI_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['QI_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.qiType" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-qi-type')" (keydown.enter)="focusSearch('focus-qi-type')">
                  <input type="search" id="focus-qi-type" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onTypeSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of typeDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME']?.isRemovable == 'Y'">
                <div>
                  <label id="qi-dept" for="department">
                    {{dynamicLabel['DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.deptCode" (closed)="departmentSearchText=''"
                  (click)="focusSearch('focus-qi-dept')" (keydown.enter)="focusSearch('focus-qi-dept')">
                  <input type=" search" id="focus-qi-dept" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onDepartmentSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-reference" for="reference">
                    {{dynamicLabel['REFERENCE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REFERENCE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REFERENCE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.reference" (closed)="referenceSearchText=''"
                  (click)="focusSearch('focus-qi-reference')" (keydown.enter)="focusSearch('focus-qi-reference')">
                  <input type="search" id="focus-qi-reference" class="dropdownsearchstyle"
                    [(ngModel)]="referenceSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onReferenceSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of referenceDropdown | assessmentSearch : referenceSearchText"
                    (onSelectionChange)="onReferenceSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="visibleReferenceIfOthers">
                <div>
                  <label id="qi-reference-others" for="reference-others">
                    Reference if Others
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="qi.referenceOthers"
                  (ngModelChange)="onNgModelChange($event,'qi-reference-others')"></textarea>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-requested-at" for="requested-at">
                    {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.requestedAt"
                  (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-qi-requested-at')"
                  (keydown.enter)="focusSearch('focus-qi-requested-at')">
                  <input type="search" id="focus-qi-requested-at" class="dropdownsearchstyle"
                    [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onRequestedAtSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch : requestedAtSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" *ngIf="qi.requestedAt">
                <div>
                  <label id="qi-business-area" for="email">
                    {{((dependency.requestedAtName ?? ' ') + " " + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea
                  [(ngModel)]="dependency.selectedBusinessArea" *ngIf="businessAreaDropdown.length"
                  (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
                  (click)="focusSearch('focus-qi-b-area')" (keydown.enter)="focusSearch('focus-qi-b-area')">
                  <input type="search" id="focus-qi-b-area" class="dropdownsearchstyle"
                    [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="dependency.isAllBusinessAreaSelected"
                      (change)="toggleAllBusinessArea()">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event, item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  *ngIf="!businessAreaDropdown.length" [(ngModel)]="qi.coreBusinessAreaName"
                  (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-evaluator" for="evaluator">
                    {{dynamicLabel['EVALUATOR_USER']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['EVALUATOR_USER']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EVALUATOR_USER']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.evaluator" (closed)="evaluatorSearchText=''"
                  (keydown.enter)="focusSearch('focus-qi-evaluator')" (click)=" focusSearch('focus-qi-evaluator')">
                  <input type="search" id="focus-qi-evaluator" class="dropdownsearchstyle"
                    [(ngModel)]="evaluatorSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onEvaluatorSelect($event,null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of evaluatorDropdown | assessmentSearch : evaluatorSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onEvaluatorSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-identified-on" for="qi-identified-on">
                    {{dynamicLabel['IDENTIFIED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['IDENTIFIED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IDENTIFIED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qi.identifiedOn" (ngModelChange)="onNgModelChange($event, 'qi-identified-on')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="qi-ex-to-be-started-on" for="qi-expected-to-started-on">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qi.expectedToBeStartedOn" (ngModelChange)="onExpectedToBeStartedOnChange($event);">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-closure-on" for="qi-closure-on">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qi.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(dv.expcetedClosureOn, 'qi-closure-on')">
              </div>

              <div class="col-md-6">
                <div>
                  <label id="qi-short-description" for="email">
                    {{dynamicLabel['SHORT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers shortDescription" type="text" placeholder="" maxlength="100"
                  [(ngModel)]="qi.shortDescription">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="qi-impact-type" for="qi-impact-type">
                    {{dynamicLabel['IMPACT_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qi.impactType" (closed)="impactTypeSearchText=''"
                  (click)="focusSearch('focus-qi-impact-type')" (keydown.enter)="focusSearch('focus-qi-impact-type')">
                  <input type="search" id="focus-qi-impact-type" class="dropdownsearchstyle"
                    [(ngModel)]="impactTypeSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onImpactTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of impactTypeDropdown | assessmentSearch : impactTypeSearchText"
                    (onSelectionChange)="onImpactTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['DESCRIPTION']?.isRemovable=='Y'">
                <div>
                  <label id="qi-description" for="email">
                    {{dynamicLabel['DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qi.description" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(qi.description, 'qi-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Description')"
                      (keydown.enter)="openEditor('Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div>
                  <label id="qi-impact-description" for="qi-impact-description">
                    {{dynamicLabel['IMPACT_DESCRIPTION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qi.impactDescription" [config]="excludeButtons" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange(qi.impactDescription,'qi-impact-description')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Impact Description')"
                      (keydown.enter)="openEditor('Impact Description')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-3" *ngIf="dependency.groupDetail?.effectivenessCheckEnabled == 'Y'">
                <div>
                  <label for="email">
                    {{dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qi.effectivenessCheckReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: qi.effectivenessCheckReqd ? 'green' : 'red' }">
                    {{ qi.effectivenessCheckReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qi.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: qi.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ qi.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <!-- ************************** Customer Complaint *********************************** -->
            <ng-container *ngIf="dependency.module == 'CC'">
              <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_TITLE']?.isRemovable == 'Y'">
                <div>
                  <label id="title" for="title">
                    {{dynamicLabel['REPORTER_TITLE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TITLE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_TITLE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cc.reporterTitle"
                  (closed)="reporterTitleSearchText=''" (click)="focusSearch('focus-title')"
                  (keydown.enter)="focusSearch('focus-title')">
                  <input type="search" id="focus-title" class="dropdownsearchstyle"
                    [(ngModel)]="reporterTitleSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onReporterTitleSelect($event, null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of reporterTitleDropdown | assessmentSearch : reporterTitleSearchText"
                    (onSelectionChange)="onReporterTitleSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="first-name" for="first-name">
                    {{dynamicLabel['REPORTER_FIRST_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FIRST_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_FIRST_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterFirstName"
                  (ngModelChange)="onNgModelChange($event,'first-name')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_MIDDLE_NAME']?.isRemovable == 'Y'">
                <div>
                  <label for="middle-name">{{dynamicLabel['REPORTER_MIDDLE_NAME']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_MIDDLE_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_MIDDLE_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterMiddleName">
              </div>

              <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_LAST_NAME']?.isRemovable != 'Y'">
                <div>
                  <label id="last-name" for="last-name">
                    {{dynamicLabel['REPORTER_LAST_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_LAST_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_LAST_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterLastName"
                  (ngModelChange)="onNgModelChange($event,'last-name')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_TYPE']?.isRemovable == 'Y'">
                <div>
                  <label id="reporter-type" for="reporter-type">
                    {{dynamicLabel['REPORTER_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cc.reporterType"
                  (closed)=" reporterTypeSearchText=''" (keydown.enter)=" focusSearch('focus-reporter-type')"
                  (click)=" focusSearch('focus-reporter-type')">
                  <input type="search" id="focus-reporter-type" class="dropdownsearchstyle"
                    [(ngModel)]="reporterTypeSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onReporterTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of reporterTypeDropdown | assessmentSearch : reporterTypeSearchText"
                    (onSelectionChange)="onReporterTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['REPORTER_DESIGNATION']?.isRemovable == 'Y'">
                <div>
                  <label for="designation">{{dynamicLabel['REPORTER_DESIGNATION']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_DESIGNATION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_DESIGNATION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="designation" class="input-filed-continers" type="text" [(ngModel)]="cc.reporterDesignation">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="email-validation" for="email">{{dynamicLabel['EMAIL_ADDRESS']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['EMAIL_ADDRESS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EMAIL_ADDRESS']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="email" class="input-filed-continers" style="width: 100%;" type="email"
                  [(ngModel)]="cc.emailAddress" [matTooltip]="cc.emailAddress!">
              </div>

              <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_FAX']?.isRemovable != 'Y'">
                <div>
                  <label for="fax">{{dynamicLabel['REPORTER_FAX']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FAX']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_FAX']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="fax" class="input-filed-continers" type="text" [(ngModel)]="cc.reporterFax">
              </div>

              <div class="col-md-3">
                <div>
                  <label for="contact-no">{{dynamicLabel['REPORTER_CONTACT_NUMBER']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="contact-no" class="input-filed-continers" type="number"
                  [(ngModel)]="cc.reporterContactNumber" min="0" (keypress)="validateMobileNumber($event)">
              </div>

              <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_ADDRESS2']?.isRemovable != 'Y'">
                <div>
                  <label for="contact-no-off">
                    {{dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="contact-no-off" class="input-filed-continers" type="number"
                  [(ngModel)]="cc.reporterContactNumberOffice" min="0" (keypress)="validateMobileNumber($event)">
              </div>

              <div class="col-md-6">
                <div>
                  <label id="address-field1" for="address-field1">
                    {{dynamicLabel['REPORTER_ADDRESS1']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS1']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ADDRESS1']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea id="reporterAddress1" type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="cc.reporterAddress1" (input)="validateAddress($event)"></textarea>
              </div>

              <div class="col-md-6" [hidden]="dynamicLabel['REPORTER_ADDRESS2']?.isRemovable == 'Y'">
                <div>
                  <label id="address-field2" for="address-field2">
                    {{dynamicLabel['REPORTER_ADDRESS2']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS2']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ADDRESS2']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea id="reporterAddress2" type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="cc.reporterAddress2" (input)="validateAddress($event)"></textarea>
              </div>

              <div class="col-md-3">
                <div>
                  <label for="city">{{dynamicLabel['REPORTER_CITY']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CITY']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CITY']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterCity">
              </div>

              <div class="col-md-3">
                <div>
                  <label for="state">{{dynamicLabel['REPORTER_STATE']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_STATE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_STATE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterState">
              </div>

              <div class="col-md-3" *ngIf="dynamicLabel['REPORTER_COUNTRY']?.isRemovable != 'Y'">
                <div>
                  <label for="country">{{dynamicLabel['REPORTER_COUNTRY']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COUNTRY']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_COUNTRY']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="cc.reporterCountry"
                  (closed)="countrySearchText=''" (keydown.enter)="focusSearch('focus-country')"
                  (click)="focusSearch('focus-country')">
                  <input type="search" id="focus-country" class="dropdownsearchstyle" [(ngModel)]="countrySearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of countryDropdown | assessmentSearch : countrySearchText"
                    [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label for="zip-code">{{dynamicLabel['REPORTER_ZIPCODE']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ZIPCODE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ZIPCODE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" [(ngModel)]="cc.reporterZipcode" min="0">
              </div>

              <div class="col-md-6">
                <div>
                  <label id="comments" for="comments">
                    {{dynamicLabel['REPORTER_COMMENTS']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COMMENTS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_COMMENTS']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="cc.reporterComments" [config]="excludeButtons" [spellcheck]="true"
                      (paste)="onPaste($event)"
                      (ngModelChange)="onStEditorChange(cc.reporterComments,'comments')"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit">
                    <i class="far fa-edit" (click)="openEditor('Reporter Comments')"
                      (keydown.enter)="openEditor('Reporter Comments')"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-2" *ngIf="dependency.groupDetail?.isRiskCalculationReqd == 'Y'">
                <div>
                  <label for="email"> {{dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldName}} </label>
                  <span style="float:right" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="cc.isRiskCalculationReqd">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: cc.isRiskCalculationReqd ? 'green' : 'red' }">
                    {{ cc.isRiskCalculationReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </ng-container>

            <ng-container *ngIf="dependency.module == 'OOS'">
              <div class="col-md-3">
                <div>
                  <label id="oost-type" for="email">
                    {{dynamicLabel['OOST_TYPE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OOST_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OOST_TYPE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="oos.oostType" (closed)="typeSearchText=''"
                  (keydown.enter)="focusSearch('oost-search')" (click)="focusSearch('oost-search')">
                  <input type="search" id="oost-search" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" (onSelectionChange)="onOostTypeSelect($event, null)"
                    [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of oostDropdown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onOostTypeSelect($event, item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['INITIATING_DEPT_NAME']?.isRemovable=='Y'">
                <div>
                  <label id="initiating-dept" for="email">
                    {{dynamicLabel['INITIATING_DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['INITIATING_DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['INITIATING_DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>

                <mat-select matInput placeholder="Select" [(ngModel)]="oos.initiatingDeptCode"
                  (closed)="initiatingDepartmentSearchText=''" (keydown.enter)="focusSearch('focus-initiating-dept')"
                  (click)="focusSearch('focus-initiating-dept')">
                  <input type="search" id="focus-initiating-dept" class="dropdownsearchstyle"
                    [(ngModel)]="initiatingDepartmentSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onInitiatingDepartmentSelect($event, null)">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of departmentDropdown | assessmentSearch : initiatingDepartmentSearchText"
                    (onSelectionChange)="onInitiatingDepartmentSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['OOS_DEPT_NAME']?.isRemovable=='Y'">
                <div>
                  <label id="oos-dept" for="email">
                    {{oos.oostType}}&nbsp;{{dynamicLabel['OOS_DEPT_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OOS_DEPT_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OOS_DEPT_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="oos.oosDeptCode"
                  (closed)="departmentSearchText=''" (click)="focusSearch('focus-oos-dept')"
                  (keydown.enter)="focusSearch('focus-oos-dept')">
                  <input type="search" id="focus-oos-dept" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="oos-owner" for="email">
                    {{dynamicLabel['OWNER_USER_NAME']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OWNER_USER_NAME']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="oos.owner" (closed)="ownerSearchText=''"
                  (click)="focusSearch('focus-oos-owner')" (keydown.enter)="focusSearch('focus-oos-owner')">
                  <input type="search" id="focus-oos-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onOwnerSelect($event, null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of ownerDropdown | assessmentSearch : ownerSearchText"
                    (onSelectionChange)="onOwnerSelect($event, item)" [value]="item.valueExp"
                    [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-3">
                <div>
                  <label id="oos-occurrence" for="oos-occurrence">
                    {{dynamicLabel['DATE_OF_OCCURRENCE']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['DATE_OF_OCCURRENCE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DATE_OF_OCCURRENCE']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="oos.dateOfOccurrence"
                  (ngModelChange)="onOosOccurrenceChange($event); onNgModelChange(oos.dateOfOccurrence, 'oos-occurrence')">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="oos-identified-on" for="oos-identified-on">
                    {{dynamicLabel['IDENTIFIED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['IDENTIFIED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IDENTIFIED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getIdentifiedOnConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="oos.identifiedOn"
                  (ngModelChange)="onNgModelChange(oos.identifiedOn, 'oos-identified-on')">
              </div>

              <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
                <div>
                  <label id="oos-ex-to-be-started-on" for="oos-expected-to-started-on">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$present_future_config" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="oos.expectedToBeStartedOn" (ngModelChange)="onExpectedToBeStartedOnChange($event);">
              </div>

              <div class="col-md-3">
                <div>
                  <label id="oos-closure-on" for="oos-closure-on">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="$getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="oos.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange(dv.expcetedClosureOn, 'oos-closure-on')">
              </div>
            </ng-container>
          </div>

          <div class="ActivityPage" id="Additionaldetail" style="margin-top: 15px;"
            *ngIf="dependency.module && dependency.showModule && dynamicLabel">
            <app-flexible-fields #flexible [from]="'Dependency'" [dependency]="dependency"></app-flexible-fields>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="dependency.mode == 'map'">
        <div class="row">
          <div class="col-md-3">
            <div>
              <label id="map-module" for="email">Module</label>
              <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="mapDependency.module" (closed)="moduleSearchText=''"
              (click)="focusSearch('focus-map-module')" (keydown.enter)="focusSearch('focus-map-module')">
              <input type="search" id="focus-map-module" class="dropdownsearchstyle" [(ngModel)]="moduleSearchText"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of moduleDropdown | assessmentSearch : moduleSearchText"
                (onSelectionChange)="onMapModuleSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <ng-container *ngIf="mapDependency.module">

            <div class="col-md-6">
              <div>
                <label for="email">Group</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="mapDependency.groupId"
                (closed)="groupSearchText=''" (click)="focusSearch('map-group-search')"
                (keydown.enter)="focusSearch('map-group-search')">
                <input type="search" id="map-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onMapGroupSelect($event, null)">Un-select</mat-option>
                <mat-option *ngFor="let item of groupDropdown | assessmentSearch :groupSearchText"
                  (onSelectionChange)="onMapGroupSelect($event, item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div><label for="email ">{{mapDependency.selectedModule}} No</label></div>
              <input class="search-filed-continers" type="text" [(ngModel)]="mapDependency.refNo">
            </div>

            <div class="col-md-3">
              <div><label for="email">Department</label></div>
              <mat-select matInput placeholder="Select" [(ngModel)]="mapDependency.department"
                (closed)="departmentSearchText=''" (click)="focusSearch('focus-map-dept')"
                (keydown.enter)="focusSearch('focus-map-dept')">
                <input type="search" id="focus-map-dept" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                  (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div><label for="email ">Status</label></div>
              <input class="search-filed-continers" type="text" [(ngModel)]="mapDependency.status">
            </div>
          </ng-container>

          <ng-container *ngIf="mapDependency.groupId">
            <div class=" col-md-3">
              <div><label for="email">{{mapDependency.role}}</label></div>
              <mat-select matInput placeholder="Select" [(ngModel)]="mapDependency.owner" (closed)="ownerSearchText=''"
                (click)="focusSearch('focus-map-owner')" (keydown.enter)="focusSearch('focus-map-owner')">
                <input type="search" id="focus-map-owner" class="dropdownsearchstyle" [(ngModel)]="ownerSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onOwnerSelect($event, null)">Un-select</mat-option>
                <mat-option *ngFor="let item of ownerDropdown | assessmentSearch : ownerSearchText"
                  (onSelectionChange)="onOwnerSelect($event, item)" [value]="item.valueExp"
                  [ngClass]="{'group-owner-highlight': item.displayExp === 'Group Owners'}">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </ng-container>
        </div>
        <div class="row" *ngIf="mapDependency.module">
          <div class="d-flex justify-content-center gap-3 mx-3 button-continer" mat-dialog-actions>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="searchDependencies(mapDependency)" (keydown.enter)="searchDependencies(mapDependency)">
              <span class="reload_text text-white">
                <i class="fa fa-search"></i>
                Search
              </span>
            </div>
            <button mat-stroked-button class="cancelButton" *ngIf="!mapDependency.dependencies.length"
              (click)="closeDependencyPopup()">
              <i class="fa fa-close"></i> Cancel
            </button>
            <button mat-stroked-button class="cancelButton" *ngIf="mapDependency.module" (click)="mapReset()">
              <i class="fas fa-undo"></i> Reset
            </button>
          </div>
        </div>

        <div class="table-container" *ngIf="mapDependency.dependencies.length">
          <table style="max-height: 45vh;">
            <thead>
              <th style="min-width: 60px; text-align: center;">
                <div style="display: flex;">
                  <div>
                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Task ID</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Department</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Status</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Owner</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Description</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Started On</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Completed On</span>
                </div>
              </th>

              <th
                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                  <span>Expected Closure On</span>
                </div>
              </th>

              <th class="sticky-col first-col"></th>
            </thead>
            <tbody>
              <tr class="data-row-container" *ngFor="let d of mapDependency.dependencies;">
                <td style="min-width: 80px; text-align: center;">
                  <div style="display: flex;">
                    <div [ngClass]="d.childCheckBox ?'static_icon':'hover-menu-icons'">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <div style="margin-left: 5px;">
                      <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;" [checked]="d.childCheckBox"
                        (change)="onChecked($event, d)">
                    </div>
                  </div>
                </td>
                <td class="row-data">{{ d.taskId }}</td>
                <td class="row-data">{{ d.deptCode }}</td>
                <td class="row-data">{{ d.status }}</td>
                <td class="row-data">{{ d.ownerName }}</td>
                <td class="row-data">{{ d.description }}</td>
                <td class="row-data">{{ d.startedOn | date: 'dd-MMM-yyyy HH:mm:ss' }}</td>
                <td class="row-data">{{ d.completedOn | date: 'dd-MMM-yyyy HH:mm:ss' }}</td>
                <td class="row-data">{{ d.expcetedClosureOn | date : (appService.getOneQmsDateFormat) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="create(dependency.module)" (keydown.enter)="create(dependency.module)"
          *ngIf="(dependency.mode == 'create') || (mapDependency.mappingDependency  && (mapDependency.mappingDependency | json) !== '{}')">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">{{dependency.mode == 'create' ? 'Add New' : 'Map'}}</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="closeDependencyPopup()"
          *ngIf="(dependency.mode == 'create') || mapDependency.dependencies.length">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()" (keydown.enter)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="pagedItems.length"
      (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="pagedItems.length"
      (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.isAuditTrailUser"
      (keydown.enter)="openAuditTrail('overAll',0)" (click)="openAuditTrail('overAll',0)">
      <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Audit Trail</span>
    </div>
    <div class="">
      <div class="action-buttons-container d-flex gap-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          [matMenuTriggerFor]="openMenu"
          *ngIf="(qualityService.moduleName != 'AU' && message.showDependencyActionButton) || (qualityService.moduleName == 'AU' && getAuditPrivilege())">
          <img src=" ../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container" *ngIf="pagedItems.length">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container" *ngFor="let header of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': header.width, 'max-width': header.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
      class="sticky-dynamic-col1" (mouseover)="cssFunction(0)" (focus)="focusEmpty()">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{header.fieldColumnarray}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div class="sort" (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],header)"
            (click)="sortColumn(columnLists.columnsListarray[ix],header)">
            <div>
              <i *ngIf="sortedDisplayColumn==header.fieldColumnarray && sortDirection=='asc'" class='fas fa-angle-up'
                style='font-size:11px'></i>
            </div>
            <div>
              <i *ngIf="sortedDisplayColumn==header.fieldColumnarray && sortDirection=='desc'" class='fas fa-angle-down'
                style='font-size:11px'></i>
            </div>
            <img *ngIf="sortedDisplayColumn!=header.fieldColumnarray" src="../../../assets/img/qms_img/sort.svg"
              width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th class="sticky-col first-col"></th>
    <tr>
      <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></td>
      <td *ngFor="let column of columnLists.fieldColumnarray; let ix = index;" class="sticky-dynamic-col1"
        [ngStyle]="{'min-width': column.width !=null ? column.width :200,'max-width': column.width !=null ? column.width :200}">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <!-- data row -->
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBox == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
        class="sticky-dynamic-row1" (mouseover)="cssFunction(i)" (focus)="focusEmpty()"
        [ngStyle]="{'min-width': key.width !=null ? key.width :200,'max-width': key.width !=null ? key.width :200,'overflow': 'hidden','text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
        (click)="navigate(list,i)" (keydown.enter)="navigate(list,i)">
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>
        <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray]!='htmlClobView'">
          {{ list[key.columnsListarray] }}
        </span>
        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClob(list,key.columnsListarray,columnLists.fieldColumnarray[i]?.fieldColumnarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>
      </td>

      <td class="sticky-col first-col" *ngIf="message.showDependencyActionButton">
        <div class="action-icons">
          <img src="../../../assets/img/cr_module/delete.svg" width="16" height="16" alt="delete"
            matTooltip="UnMap Task Dependency" (keydown.enter)="openDeletePopup(list)"
            (click)="openDeletePopup(list)" />
          <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
            src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)"
            (keydown.enter)="openAuditTrail('individual',list)" />
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center" *ngIf="pagedItems.length">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" class="ng-drop-down-basic"
            ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
  <div class="d-none">
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav aria-label="nav" class="col-4 col-md-2 mt-2"> </nav>
      <div class="col-2 col-md-6 d-flex justify-content-end align-items-center"> </div>
      <nav aria-label="nav" class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " class="ng-drop-down-basic" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
    </div>
  </div>
</div>

<mat-menu #openMenu="matMenu">
  <button mat-menu-item (click)="openAddDependencyPopup('create')" (keydown.enter)="openAddDependencyPopup('create')">
    Add New Dependency
  </button>
  <button mat-menu-item (click)=" openAddDependencyPopup('map')" (keydown.enter)="openAddDependencyPopup('map')">
    Map Existing Dependency
  </button>
</mat-menu>


<ng-template #deleteDependencyPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeDeletePopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popup.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label id="unmap-reason" for="email">Reason for Unmap</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="deleteDependency.deleteReason"
            (ngModelChange)="onNgModelChange(deleteDependency.deleteReason, 'unmap-reason')"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteDependent()">
        <i class="fa fa-trash"></i> Unmap
      </button>
      <button mat-stroked-button class="cancelButton" (click)="closeDeletePopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{this.editorTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="includeButtons" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="saveEditor()">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>